import _ from "lodash";
import Api from "./fnapi-client";
import Storage from "./storage";
import * as config from "../config";
import Promise from "es6-promise"
export default {

  /*********************************************************************************************************************
   Token and logged in storage
   *********************************************************************************************************************/

  getToken: function(){
    if (Storage.get("token")) {
      return (Storage.get("token"));
    }
    else {
      return null;
    }
  },

  setToken:function(token){
    Storage.set("token", token);
  },

  loggedIn:function(){
    let token = this.getToken();
    return token !== null;
  },

  clearAuth: function(){
    Storage.unset("token");
  },

  logout: function(apiDelete = true){
    if(!this.loggedIn()) {
      return
    }
    if (apiDelete) {
      Api.delete("user/current/token")
    }

    // LOGGLY: safely check for user guid existing, save to local variable
    Storage.unset("user");
    Storage.unset("token");
    Storage.set("user_guid", JSON.stringify(createGuid())); //createGuid()? Whats this for
    // LOGGLY: safely add user guid back onto local storage
  },

  /*********************************************************************************************************************
   User Storage
   *********************************************************************************************************************/

  getUser: function(){
    return Storage.get("user");
  },

  setUser:function(user){
    Storage.set("user",user);
  },

  /*********************************************************************************************************************
   Logging (Should this really be in the UserHandler class???
   *********************************************************************************************************************/

  createUserFromApiResponse(userResponse){
    let {uid, email, name, companyName} = userResponse;
    if (!companyName) {
      companyName = ""
    }
    return {
      id: uid,
      email,
      name,
      companyName,
      friendlyIdentifier: name ? name : email
    }
  },

  logToLogglySimple: function(message) {
    // LOGGLY: ensure that we also add the user guid to this and that it gets properly logged
    var log = {
      "status": 999,
      "ok": false,
      "message": message
    };

    _LTracker.push(log);
  },

  logToLogglyWithAPIResponse: function(
    message,
    method,
    fullURL,
    reqHeaders,
    reqBody,
    apiResponse,
    apiCallTimeEndToEnd
  )
  {
    // LOGGLY: ensure that we also add the user guid to this and that it gets properly logged
    var log = {
      "status": 999,
      "method": method,
      "ok": false,
      "message": message,
      "url": fullURL,
      "reqBody": reqBody, // Loggly does not allow "requestBody" as a name of a param
      "reqHeaders": reqHeaders,
      "apiResponse": apiResponse,
      "apiCallTimeEndToEnd": apiCallTimeEndToEnd
    };

    _LTracker.push(log);
  },




  /*********************************************************************************************************************
   UNSURE ABOUT ANYTHING BELOW THESE LINES
  *********************************************************************************************************************/



  checkTokenValidOrLogout: function(){
    // LOGGLY: reimpliment without promises
    return new Promise(
      (resolve, reject) => {
      if (!this.loggedIn()) {
        return resolve({});
      }
      else {
        this.setUserObjectFromApi().then( (response) => {
          return resolve(response);
        }).catch( (error) => {
          if (error.subCode == "badUserToken"){
            this.logout(false);
          }
          return reject( error );
        });
      }
    });
  },

  setUserObjectFromApi: function(){
    return Api.get("user/current").then( (response) => {
      let user = this.createUserFromApiResponse(response.data);
      this.setUser(user);
    });
  },

  setErrorMessage:function(errorMessage){
    Storage.set("error_message",errorMessage);
  },

  getErrorMessage: function(){
    if (Storage.get("error_message")) {
      let errorMessage = Storage.get("error_message");
      Storage.unset("error_message");
      return errorMessage;
    }
    else {
      return null
    }
  },

  setResendEmail:function(resendEmail){
    Storage.set("resend_email",resendEmail);
  },

  getResendEmail: function() {
    if (Storage.get("resend_email")) {
      return Storage.get("resend_email");
    }
    else {
      return ""
    }
  },

  removeResendEmail: function(){
    Storage.unset("resend_email");
  },

  setUsageConsoleLastVisited: function(time){
    Storage.set("usage_console_last_visited", time);
  },

  getUsageConsoleLastVisited: function() {
    if (Storage.get("usage_console_last_visited")) {
      return Storage.get("usage_console_last_visited");
    }
    else {
      return ""
    }
  },

  setOpenMenuItems: function(time){
    Storage.set("open_menu_items", time);
  },

  getOpenMenuItems: function() {
    if (Storage.get("open_menu_items")) {
      return Storage.get("open_menu_items");
    }
    else {
      return ""
    }
  },

  removeOpenMenuItems: function(){
    Storage.unset("open_menu_items");
  },


  setHasEnteredProduction: function(enteredProduction){
    Storage.set("entered_production", enteredProduction);
  },

  getHasEnteredProduction: function() {
    if (Storage.get("entered_production")) {
      return Storage.get("entered_production");
    }
    else {
      return ""
    }
  },

};



// WEBPACK FOOTER //
// ./src/js/utilities/user-handler.jsx